<template>
	<div class="box-loading">
		<span class="loader"></span>
	</div>
</template>

<script>
</script>

<style scoped>
.box-loading {
	width: 100%;
	min-height: 100vh;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loader {
	width: 48px;
	height: 48px;
	border: 5px solid #fff;
	border-bottom-color: transparent;
	border-radius: 50%;
	display: inline-block;
	box-sizing: border-box;
	animation: rotation 1s linear infinite;
}

@keyframes rotation {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
